module.exports = __webpack_public_path__ + "img/male.8fdbd35a.png";